import { TextField } from '@mui/material';
import styled from 'styled-components';

export const Parent = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;
`;

export const FilterCount = styled.div`
    margin-bottom: 0.5rem;
`;

export const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 1rem;
    justify-content: flex-end;
`;

export const DateContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    &:first-child {
        margin-right: 1rem;
    }

    &:nth-last-child(2) {
        margin-right: 0.5rem;
    }
`;

export const DateRangeContainer = styled.div`
    display: flex;
`;

export const Label = styled.label`

`;

export const StyledTextField = styled(TextField)`
    border-radius: 4px;

    fieldset {
        border: 1px solid ${(props) => (props.error ? props.theme.colors.error : props.theme.colors.border)};
    }
`;
